'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _auth = require('redux/modules/auth');

var _containers = require('containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (store) {
  var requireLogin = function requireLogin(nextState, replaceState, cb) {
    function checkAuth() {
      var _store$getState = store.getState(),
          user = _store$getState.auth.user;

      if (!user) {
        // oops, not logged in, so can't be here!
        if (nextState.location.pathname.startsWith('/register')) {
          replaceState('/auth' + nextState.location.pathname);
        } else {
          replaceState('/auth/login');
        }
      }
      cb();
    }

    if (!(0, _auth.isLoaded)(store.getState())) {
      store.dispatch((0, _auth.load)()).then(checkAuth);
    } else {
      checkAuth();
    }
  };

  var onEnterIndex = function onEnterIndex(nextState, replaceState, cb) {
    requireLogin(nextState, replaceState, function () {});

    // If user has a single calendar, redirect to that calendar

    var _store$getState2 = store.getState(),
        user = _store$getState2.auth.user;

    if (user.calendars && user.calendars.length === 1) {
      var id = user.calendars[0].id;

      replaceState('/calendars/' + id);
    }

    cb();
  };

  var onEnterJoin = function onEnterJoin(nextState, replaceState, cb) {
    // Don't ask to join an already joined calendar
    var _store$getState3 = store.getState(),
        user = _store$getState3.auth.user;

    if (user.calendars) {
      user.calendars.forEach(function (calendar) {
        if (calendar.id === Number(nextState.params.calendarId)) {
          replaceState('/');
        }
      });
    }

    cb();
  };

  return _react2.default.createElement(
    _reactRouter.Route,
    { component: _containers.App, path: '/' },
    _react2.default.createElement(
      _reactRouter.Route,
      { component: _containers.Authenticated, onEnter: requireLogin },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.Event, onEnter: onEnterIndex }),
      _react2.default.createElement(_reactRouter.Route, { path: 'account', component: _containers.Account }),
      _react2.default.createElement(_reactRouter.Route, { path: 'register/:calendarId/:calendarName', onEnter: onEnterJoin, component: _containers.Join }),
      _react2.default.createElement(_reactRouter.Route, { path: 'calendars/:calendarId/settings', component: _containers.Event }),
      _react2.default.createElement(_reactRouter.Route, { path: 'calendars/:calendarId', component: _containers.Event }),
      _react2.default.createElement(_reactRouter.Route, { path: 'calendars/:calendarId/widget', component: _containers.Event }),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'calendars', component: _containers.Event },
        _react2.default.createElement(_reactRouter.Route, { path: ':calendarId', component: _containers.Event }),
        _react2.default.createElement(_reactRouter.Route, { path: ':calendarId/events/:id', component: _containers.Event })
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'events', component: _containers.Event },
        _react2.default.createElement(_reactRouter.Route, { path: ':id', component: _containers.Event })
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'notifications', component: _containers.Notification },
        _react2.default.createElement(_reactRouter.Route, { path: 'archived' })
      ),
      _react2.default.createElement(_reactRouter.Route, { path: 'organizations', component: _containers.Organization }),
      _react2.default.createElement(_reactRouter.Route, { path: 'organizations/:id', component: _containers.Organization }),
      _react2.default.createElement(_reactRouter.Route, { path: 'users', component: _containers.User }),
      _react2.default.createElement(_reactRouter.Route, { path: 'users/:id', component: _containers.User }),
      _react2.default.createElement(_reactRouter.Route, { path: 'venues', component: _containers.Venue }),
      _react2.default.createElement(_reactRouter.Route, { path: 'venues/:id', component: _containers.Venue }),
      _react2.default.createElement(_reactRouter.Route, { path: 'taxonomies/:slug', component: _containers.Term }),
      _react2.default.createElement(_reactRouter.Route, { path: 'taxonomies/:slug/terms/:id', component: _containers.Term })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { component: _containers.Guest },
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'auth' },
        _react2.default.createElement(_reactRouter.Route, { path: 'login', component: _containers.Login }),
        _react2.default.createElement(_reactRouter.Route, { path: 'code', component: _containers.LoginCode }),
        _react2.default.createElement(_reactRouter.Route, { path: 'register', component: _containers.Register }),
        _react2.default.createElement(_reactRouter.Route, { path: 'register/:calendarId/:calendarName', component: _containers.Register }),
        _react2.default.createElement(_reactRouter.Route, { path: 'activate/:name/:email/:id/:token', component: _containers.Activate })
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'password' },
        _react2.default.createElement(_reactRouter.Route, { path: 'email', component: _containers.PasswordEmail }),
        _react2.default.createElement(_reactRouter.Route, { path: 'reset/:token', component: _containers.PasswordReset }),
        _react2.default.createElement(_reactRouter.Route, { path: 'reset/:token/:email', component: _containers.PasswordReset })
      )
    ),
    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _containers.NotFound, status: 404 })
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = 2305
// module chunks = 0